// Dialog »Benutzer bearbeiten« (Admin): Tabs Stammdaten | Fortbildung.
// Eigene Datei, damit sowohl die User-Liste (manage.js) als auch die CME-Ansicht (cme.js) ihn öffnen können.
import { Stack, Tabs, Tab, Box, Dialog, DialogTitle, DialogContent, TextField, FormControl, InputLabel, Select, MenuItem, Typography, DialogActions, Button } from "@mui/material";
import { Mail } from "@mui/icons-material";
import { useState, useEffect } from "react";
import {useGlobal} from 'reactn';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import '@sweetalert2/theme-material-ui/material-ui.css';
import { Bereichsauswahl } from "./utils";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { UserCmeTab } from "./usercme";

const swal = withReactContent(Swal)

// onMessage(user): optional – wechselt ins Nachrichtencenter mit dem Benutzer als Empfänger
export function Edituser({user,close,initialTab=0,onMessage}) {
    const [axios] = useGlobal('axios')
    const [toggletasks,setToggletasks] = useGlobal('tasks')
    const [moduser,setModuser] = useState({})
    const [password,setPassword] = useState('')
    const [pw2,setPw2] = useState('')
    const [tab,setTab] = useState(0)

    useEffect(() => {
        if (user) {
            setModuser(user)
        } else {
            setModuser({})
        }
        setTab(initialTab)
    },[user,initialTab])

    const checkExisting = () => {
        axios.post('check_existing',{email:moduser.email}).then(resp => 
          {if (resp.data.exists) {
            swal.fire({
              text : 'Email-Adresse schon belegt',
             confirmButtonText: 'ok',
              }).then(r => setModuser({...moduser,email:''}))
          }})
      }

    const handleUpdate = () => {axios.post('updateuser',{...moduser,password:password}).then(resp =>{
       console.log('adminupdate',resp)
       close()
      })
    }

    const deleteUser = () => {
        swal.fire({
            text : 'Benutzer entgültig löschen?',
            confirmButtonText: 'Ja',
            showCancelButton: true,
            cancelButtonText: 'Nein',
            type : 'warning',
        }).then(data => {
            if (data.value) {
             axios.post('deleteUser',{_id:user._id}).then(res => {
                setToggletasks(!toggletasks)
                close()
             })
            }
        })

    }

    const freigeben = () => {
        axios.post('freigeben',{_id:user._id}).then(res => {
            setToggletasks(!toggletasks)
            close()
        })
    }

return (
    <Dialog open={Boolean(user)} fullWidth maxWidth='md'>
        <DialogTitle>{user?.name ? `${user.name.vorname} ${user.name.nachname}` : 'Benutzer bearbeiten'}</DialogTitle>
        <Tabs value={tab} onChange={(e,v) => setTab(v)} sx={{px:3, borderBottom:1, borderColor:'divider'}}>
            <Tab label='Stammdaten'/>
            <Tab label='Fortbildung'/>
        </Tabs>
        <DialogContent>
    {tab === 1 && <Box sx={{mt:1}}><UserCmeTab user={user} moduser={moduser} setModuser={setModuser}/></Box>}
    {tab === 0 &&
    <Stack spacing={2} sx={{mt:1}}>
      <TextField label="Email-Adresse" value={moduser.email || ''} helperText='Adresse ist gleichzeitig Login-Name' error={!moduser?.email || !moduser?.email.includes('@')} fullWidth onChange={e => setModuser({...moduser,email:e.target.value})} onBlur={e => checkExisting()}/>
      <Stack direction={{xs:'column', sm:'row'}} spacing={2}>
        <TextField label="Passwort" value={password} error={password.length < 5} type='password' fullWidth onChange={e => setPassword(e.target.value)}/>
        <TextField label="Passwort wiederholen" error={pw2 !== password} value={pw2} type='password' fullWidth onChange={e => setPw2(e.target.value)}/>
      </Stack>
      <Stack direction={{xs:'column', sm:'row'}} spacing={2}>
        <FormControl sx={{minWidth:110}}>
        <InputLabel>Anrede</InputLabel>
        <Select value={moduser?.anrede || ''} label='Anrede' onChange={e => setModuser({...moduser,anrede:e.target.value})}>
          <MenuItem value={'Herr'}>Herr</MenuItem>
          <MenuItem value={'Frau'}>Frau</MenuItem>
        </Select>
        </FormControl>
        <TextField label='Vorname' fullWidth error={!moduser?.name?.vorname} value={moduser?.name?.vorname || ''} onChange={e => setModuser({...moduser,name:{...moduser?.name,vorname:e.target.value}})}/>
        <TextField label='Nachname' fullWidth error={!moduser?.name?.nachname} value={moduser?.name?.nachname || ''} onChange={e => setModuser({...moduser,name:{...moduser?.name,nachname:e.target.value}})}/>
      </Stack>
      <TextField label='Handynummer' fullWidth helperText='für dringende SMS' value={moduser?.mobile || ''} onChange={e => setModuser({...moduser,mobile:e.target.value})}/>
      <div>
        <Typography variant='subtitle1'>NEF-Bereiche</Typography>
        <Bereichsauswahl  selected={moduser?.groups || []} change={g => setModuser({...moduser,groups:[...g]})}/>
      </div>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
      <MobileDatePicker    label="Erster Notarzt-Dienst"
        inputFormat="dd.MM.yyyy"
        value={moduser?.nastart}
        onChange={n => setModuser({...moduser,nastart:n})}
        renderInput={(params) => <TextField {...params} helperText='Datum des ersten Notarzt-Dienstes'/>}
      />
      </LocalizationProvider>
    </Stack>
    }
        </DialogContent>
        <DialogActions>
        {onMessage && <Button variant="outlined" startIcon={<Mail/>} sx={{mr:'auto'}} onClick={(event) => {close(); onMessage(user)}}>Nachricht an Benutzer</Button>}
        <Button variant="text" color="primary" onClick={(event) => close()}>abbrechen</Button>
        <Button variant="outlined" color="error" onClick={(event) => deleteUser()}>User löschen</Button>
            {user.pending && <Button variant="contained" color="primary" primary="true" onClick={(event) => freigeben()}>Freigeben</Button>}
            <Button variant="contained" color="primary" primary="true" onClick={(event) => handleUpdate()}>speichern</Button>

        </DialogActions>
    </Dialog>
)
}


